import React, { ReactNode } from "react";
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from "@mui/material";
import { Theme, ThemeProvider } from "@emotion/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@bn/api";
import { MandatorContextProvider } from "@bn/theming";
import { useLocalizedTheme } from "@bn/theming";

import { ErrorBoundary } from "@components";
import { SnackbarProvider } from "@providers";
import { SecurityImagesProvider } from "@providers";
import { SharedModalProvider } from "@providers/SharedModalProvider.tsx";
import { MandatorMetaSync } from "@providers/MandatorMetaSync";
import { useMandatorSpecificTranslations } from "@hooks";
import { getDefaultMandatorSlug } from "@helpers";
import { ApiProvider } from "@providers/ApiProvider.tsx";

export const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  const { theme } = useLocalizedTheme();
  useMandatorSpecificTranslations();

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={theme as Partial<Theme>}>
          {children}
        </ThemeProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};

export const AppWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <ErrorBoundary>
      <ApiProvider>
        <QueryClientProvider client={queryClient}>
          <SecurityImagesProvider>
            <MandatorContextProvider
              defaultMandatorSlug={getDefaultMandatorSlug()}
            >
              <MandatorMetaSync />
              <ThemeProviderWrapper>
                <SharedModalProvider>
                  <SnackbarProvider>{children}</SnackbarProvider>
                </SharedModalProvider>
              </ThemeProviderWrapper>
            </MandatorContextProvider>
          </SecurityImagesProvider>
        </QueryClientProvider>
      </ApiProvider>
    </ErrorBoundary>
  );
};
